var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isUpdateAvailable ? _c("app-update") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-wrap" },
        [
          _c("app-header"),
          _vm._v(" "),
          _c(
            "main",
            {
              class: {
                "main-homepage": _vm.isHomePage,
                "min-header": _vm.isMinHeader,
              },
            },
            [
              _c("router-view", { staticClass: "router-view" }),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide", mode: "out-in" } },
                [_vm.message ? _c("global-message") : _vm._e()],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isFullFooter ? _c("app-footer") : _vm._e(),
      _vm._v(" "),
      !_vm.isFullFooter ? _c("app-footer-minimal") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }